import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { IonInput } from '@ionic/react';
import { AxiosResponse } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import NumberFormat from 'react-number-format';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import {
  BsResponse,
  BinaryBetrequest,
  PlaceBetRequest,
} from '../../models/BsData';
import API from '../../api';
import {
  exchangeBetOddsChange,
  fetchBalance,
  removeExchangeBet,
  setExchangeBetStake,
  clearExchcngeBets,
  fetchOpenBets,
  addOpenBets,
  setBettingInprogress,
  cancelBetSuccess,
  getAllMarketsByEvent,
  getSecondaryMatchOddsByEvent,
} from '../../store';
import { RootState } from '../../models/RootState';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { ButtonVariable } from '../../models/ButtonVariables';
import { getBetTimeoutByMarket } from '../../util/stringUtil';
import './ExchBetslip.scss';
import { isMobile } from 'react-device-detect';
import { EventDTO } from '../../models/common/EventDTO';
import { useMarketLocalState } from '../../hooks/storageHook';
import { useLocation } from 'react-router-dom';
import { MatchOddsDTO } from '../../models/common/MatchOddsDTO';
import {
  DisabledMarketDTO,
  SuspendedMarketDTO,
} from '../../models/common/SuspendedMarketDTO';
import {
  triggerFetchOrders,
  updateDisabledMarkets,
  updateSuspendedMarkets,
} from '../../store/exchangeSports/exchangeSportsActions';
import {
  triggerMultiFetchOrders,
  updateMultiDisabledMarkets,
  updateMultiSuspendedMarkets,
} from '../../store/multimarket/multimarketAction';

type StoreProps = {
  balance: number;
  exposure: number;
  bets: PlaceBetRequest[];
  oneClickAmount: number;
  isOneClickEnable: boolean;
  selectedEventType: { id: ''; name: ''; slug: '' };
  fetchBalance: () => void;
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: 'ADD' | 'SET'
  ) => void;
  clearExchangeBets: () => void;
  selectedEvent: SelectedObj;
  fetchOpenBets: (eventId: string | string[]) => void;
  addOpenBets: (openBets) => void;
  buttonVariables: ButtonVariable[];
  bettingInprogress: boolean;
  cancelBetSuccess: (betId: string) => void;
  setBettingInprogress: (val: boolean) => void;
  // fetchOpenBetsSuccess: (openbets: any) => void;
  mobileView: boolean;
  secondaryMatchOdds: MatchOddsDTO[];
  updateDisabledMarkets: (disabledMarket: DisabledMarketDTO) => void;
  updateMultiDisabledMarkets: (disabledMarket: DisabledMarketDTO) => void;
  updateSuspendedMarkets: (suspendedMarket: SuspendedMarketDTO) => void;
  updateMultiSuspendedMarkets: (suspendedMarket: SuspendedMarketDTO) => void;
  triggerFetchOrders: () => void;
  triggerMultiFetchOrders: (eventId: string) => void;
};

const ExchBetslip: React.FC<StoreProps> = (props) => {
  const {
    balance,
    exposure,
    bets,
    oneClickAmount,
    isOneClickEnable,
    fetchBalance,
    cancelBetSuccess,
    selectedEventType,
    exchangeBetOddsChange,
    removeExchangeBet,
    setExchangeBetStake,
    clearExchangeBets,
    selectedEvent,
    fetchOpenBets,
    addOpenBets,
    buttonVariables,
    bettingInprogress,
    setBettingInprogress,
    mobileView,
    secondaryMatchOdds,
    updateDisabledMarkets,
    updateMultiDisabledMarkets,
    updateSuspendedMarkets,
    updateMultiSuspendedMarkets,
    triggerFetchOrders,
    triggerMultiFetchOrders,
  } = props;

  const location = useLocation();
  const pathName = location.pathname;
  const [multiMarketData] = useMarketLocalState();
  const [showSpinner, setShowSpinner] = useState<boolean>(true);
  const [spinCounter, setSpinCounter] = useState<number>(5);
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [successMsg, setSuccessMsg] = useState<string>('');
  const marketTypeMap: { [key: string]: string } = {
    MO: 'MATCH_ODDS',
    BM: 'MATCH_ODDS',
    FANCY: 'FANCY',
  };
  let errrorDisappearTime = 4000;

  const jwt = sessionStorage.getItem('jwt_token');
  useEffect(() => {
    if (bets.length > 0 && isOneClickEnable && oneClickAmount > 0) {
      if ((mobileView && isMobile) || (!mobileView && !isMobile)) {
        setExchangeBetStake(0, oneClickAmount, 'SET');
        betPlaceHandler();
      }
    }
  }, [bets.length]);

  // useEffect(() => {
  //   if (bets?.length) {
  //     if (
  //       betsData?.length &&
  //       betsData[0]?.eventId === bets[0]?.eventId &&
  //       betsData[0]?.marketId === bets[0]?.marketId &&
  //       betsData[0]?.outcomeId === bets[0]?.outcomeId &&
  //       betsData[0]?.betType === bets[0]?.betType
  //     ) {
  //       if (betsData[0].oddValue !== bets[0].oddValue) {
  //         // deep  copy concept
  //         setBetsData(JSON.parse(JSON.stringify(bets)));
  //         setIsOddUpdate(true);
  //       }
  //     } else {
  //       setBetsData(JSON.parse(JSON.stringify(bets)));
  //     }
  //   } else {
  //     setBetsData([]);
  //   }
  // }, [bets]);

  const ValidateOdds = (bets: PlaceBetRequest[]) => {
    // Avoid multi market & check for Match Odds value
    if (pathName != '/exchange_sports/multi-markets' && secondaryMatchOdds) {
      for (let bet of bets) {
        let matchOdds = [];
        for (let mo of secondaryMatchOdds) {
          if (bet?.marketId == mo.marketId) {
            matchOdds = mo.runners;
          }
        }
        if (matchOdds && bet?.marketType === 'MO') {
          for (let mo of matchOdds) {
            if (mo.runnerId === bet.outcomeId) {
              if (bet.betType === 'BACK') {
                if (mo?.backPrices) {
                  if (bet.oddValue <= mo.backPrices[0]?.price) {
                    return false;
                  } else {
                    return true;
                  }
                }
              } else {
                if (mo?.layPrices) {
                  if (mo.layPrices[0]?.price <= bet.oddValue) {
                    return false;
                  } else {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  const betStatus = async (market: string) => {
    const startTime = new Date();
    while (1) {
      const timeNow = new Date();
      if (timeNow.getTime() - startTime.getTime() > 15000) {
        setErrorMsg('Bet not placed, timeout.');
        break;
      }

      let response: AxiosResponse<any>;
      response = await API.get('/bs/bet-status', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      });
      if (response.data.message === 'InSufficient funds') {
        setErrorMsg('InSufficient funds.');
        return;
      }
      if (
        response.data.message === 'BETTING_IN_PROGRESS' ||
        response.data.betStatus === 'PENDING'
      ) {
        await new Promise((f) =>
          setTimeout(f, getBetTimeoutByMarket[market] * 500)
        );
        continue;
      } else if (response.data.message === 'Market suspended') {
        let suspendedMarket: SuspendedMarketDTO = {
          // TODO: pass provider Id later
          providerId: '',
          sportId: bets[0]?.sportId,
          competitionId: bets[0]?.seriesId,
          eventId: bets[0]?.eventId,
          // TODO
          marketType:
            bets[0]?.marketType === 'MO'
              ? 'MATCH_ODDS'
              : bets[0]?.marketType === 'BM'
              ? 'BOOKMAKER'
              : bets[0]?.marketType,
          marketId: bets[0]?.marketId,
          suspend: true,
        };
        window.location.pathname === '/exchange_sports/multi-markets'
          ? updateMultiSuspendedMarkets(suspendedMarket)
          : updateSuspendedMarkets(suspendedMarket);
      } else if (response.data.message === 'Market disabled') {
        let disabledMarket: DisabledMarketDTO = {
          // TODO: pass provider Id later
          providerId: '',
          sportId: bets[0]?.sportId,
          competitionId: bets[0]?.seriesId,
          eventId: bets[0]?.eventId,
          // TODO
          marketType:
            bets[0]?.marketType === 'MO'
              ? 'MATCH_ODDS'
              : bets[0]?.marketType === 'BM'
              ? 'BOOKMAKER'
              : bets[0]?.marketType,
          marketId: bets[0]?.marketId,
          disable: true,
        };
        window.location.pathname === '/exchange_sports/multi-markets'
          ? updateMultiDisabledMarkets(disabledMarket)
          : updateDisabledMarkets(disabledMarket);
      }
      return response;
    }
  };

  const betPlaceHandler = async () => {
    setErrorMsg('');
    errrorDisappearTime = 4000;

    if (!sessionStorage.getItem('jwt_token')) {
      return setErrorMsg('You have to login to place bet.');
    }

    if (bets[0].amount < 1) {
      return setErrorMsg('Minimum stake amount required.');
    }

    // TODO:: Fix odds validation logic
    // if (ValidateOdds(bets)) {
    //   return setErrorMsg('Wrong odds.');
    // }

    if (+bets[0].oddLimt) {
      switch (bets[0].marketType) {
        case 'MO':
          if (bets[0].oddValue > +bets[0].oddLimt) {
            return setErrorMsg(
              'Bet not accepted. Rate over ' + bets[0].oddLimt
            );
          }
          break;

        case 'BM':
          if ((bets[0].oddValue + 100) / 100 > +bets[0].oddLimt) {
            return setErrorMsg(
              'Bet not accepted. Rate over ' + bets[0].oddLimt
            );
          }
          break;

        case 'FANCY':
          if (bets[0].oddValue / 100 + 1 > +bets[0].oddLimt) {
            return setErrorMsg(
              'Bet not accepted. Rate over ' + bets[0].oddLimt
            );
          }
          break;
      }
    }

    // if (bets[0].amount >= balance - exposure) {
    //   return setErrorMsg('Insufficient Balance.');
    // }

    if (
      (bets[0]?.minStake !== 0 && bets[0]?.minStake > bets[0].amount) ||
      (bets[0]?.maxStake !== 0 && bets[0]?.maxStake < bets[0].amount)
    ) {
      return setErrorMsg(
        'Total stake should not be less than ' +
          bets[0]?.minStake +
          ' and should not exceed ' +
          bets[0]?.maxStake
      );
    }

    // Remove spinner for fancy
    if (bets[0].marketType === 'FANCY' || bets[0].marketType === 'BM') {
      setShowSpinner(false);
    }

    if (!bets[0].oddValue) {
      setErrorMsg('Invallid Odds.');
    }

    let binaryPayload: BinaryBetrequest = null;
    let addNewBet = true;
    let url = '';

    try {
      for (const data of bets) {
        // if (data.betId) {
        //   addNewBet = false;
        //   const postBody = {
        //     cancelBets: [{ betId: data.betId, cancelSize: 0 }],
        //     marketId: data.marketId,
        //     eventId: data.eventId,
        //     sportId: data.sportId,
        //     seriesId: data.seriesId,
        //     operatorId: OPERATORID,
        //     providerId: PROVIDER_ID,
        //   };

        //   try {
        //     const cancelResponse = await API.post(
        //       `/bs/cancel-sap-bet`,
        //       postBody,
        //       {
        //         headers: {
        //           Authorization: sessionStorage.getItem('jwt_token'),
        //         },
        //       }
        //     );

        //     setShowSpinner(true);
        //     if (cancelResponse?.data?.status !== 'RS_OK') {
        //       return setErrorMsg('Unable to cancel the old bet.');
        //     } else if (cancelResponse?.data?.status === 'RS_OK') {
        //       cancelBetSuccess(data.betId);
        //     }
        //   } catch (err) {
        //     setShowSpinner(false);
        //     return setErrorMsg('Unable to cancel bet.');
        //   }
        // }

        setBettingInprogress(true);
        switch (data.marketType) {
          case 'MO': {
            url = '/place-matchodds-bet';
            break;
          }
          case 'BM': {
            url = '/place-bookmaker-bet';
            break;
          }
          case 'FANCY': {
            url = '/place-fancy-bet';
            break;
          }
          case 'PREMIUM': {
            url = '/place-premium-bet';
            break;
          }
        }
      }

      let response: AxiosResponse<BsResponse>;
      try {
        response = await API.post('/bs' + url, bets[0], {
          headers: {
            Authorization: jwt,
          },
          timeout: 1000 * 20,
        });

        if (binaryPayload !== null) {
          response = await API.post('/binary/single-bet', binaryPayload, {
            headers: {
              Authorization: jwt,
            },
          });
        }
      } catch (e) {
        setBettingInprogress(false);
        setShowSpinner(false);
        return setErrorMsg(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : 'Something went wrong'
        );
      }

      if (response.status === 200) {
        if (response?.data?.success) {
          let statusResponse: any;
          if (bets[0].marketType === 'BINARY') {
            statusResponse = response;
          } else {
            statusResponse = await betStatus(bets[0].marketType);
          }

          if (statusResponse) {
            if (statusResponse.data['success']) {
              setSuccessMsg('Bet placed successfully.');
              if (addNewBet) {
                addOpenBets(statusResponse.data.newBets);
              }
              fetchBalance();
              if (
                pathName === '/exchange_sports/multi-markets' &&
                multiMarketData
              ) {
                let eventIds = [];
                multiMarketData.forEach((item) => {
                  eventIds.push(item?.eventId);
                });
                eventIds = eventIds?.filter((item) => (item ? true : false));
                if (eventIds.length > 0)
                  triggerMultiFetchOrders(bets[0]?.eventId);
              } else {
                fetchOpenBets(bets[0].eventId);
                setTimeout(() => {
                  triggerFetchOrders();
                }, 1000);
              }
            } else {
              setErrorMsg(statusResponse.data['message']);
            }
          }
        } else {
          setBettingInprogress(false);
          setShowSpinner(false);
          return setErrorMsg(
            response?.data?.message || 'Bet is not placed, Try again'
          );
        }
      } else {
        setBettingInprogress(false);
        setShowSpinner(false);
        console.log(response);
        return setErrorMsg(
          response?.data?.message || 'Bet is not placed, Try again'
        );
      }
      setBettingInprogress(false);
      setShowSpinner(false);
      if (bets[0].amount) {
        setTimeout(() => {
          clearExchangeBets();
        }, 1000);
      }
      // if (selectedEvent) {
      //   fetchOpenBets(selectedEvent?.id, selectedEventType?.id);
      // }
    } catch (ex) {
      setBettingInprogress(false);
      setShowSpinner(false);
      setErrorMsg('Something went wrong');
    }

    setBettingInprogress(false);
    setShowSpinner(false);
  };

  useEffect(() => {
    if (bettingInprogress) {
      setTimeout(() => {
        setSpinCounter(spinCounter - 1);
      }, 900);
    } else {
      setSpinCounter(5);
    }
  }, [bettingInprogress]);

  useEffect(() => {
    if (spinCounter > 0 && spinCounter < 5) {
      setTimeout(() => {
        setSpinCounter(spinCounter - 1);
      }, 1000);
    }
  }, [spinCounter]);

  useEffect(() => {
    setTimeout(() => {
      setErrorMsg('');
    }, errrorDisappearTime);
  }, [errorMsg, errrorDisappearTime]);

  const onChangeOddHandler = (
    index: any,
    data: PlaceBetRequest,
    control: number
  ) => {
    if (data.oddValue === 1) {
      return false;
    }

    let value;
    if (control === 1) {
      let inc;
      if (data.oddValue < 2) inc = 0.01;
      else if (data.oddValue >= 2 && data.oddValue < 3) inc = 0.02;
      else if (data.oddValue >= 3 && data.oddValue < 4) inc = 0.05;
      else if (data.oddValue >= 4 && data.oddValue < 6) inc = 0.1;
      else if (data.oddValue >= 6 && data.oddValue < 10) inc = 0.2;
      else if (data.oddValue >= 10 && data.oddValue < 20) inc = 0.5;
      else if (data.oddValue >= 20 && data.oddValue < 30) inc = 1;
      else if (data.oddValue >= 30 && data.oddValue < 50) inc = 2;
      else if (data.oddValue >= 50 && data.oddValue < 100) inc = 5;
      else if (data.oddValue >= 100 && data.oddValue < 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue + inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue + inc).toFixed(2)
          : data.oddValue;
    } else {
      let inc;
      if (data.oddValue <= 2) inc = 0.01;
      else if (data.oddValue > 2 && data.oddValue <= 3) inc = 0.02;
      else if (data.oddValue > 3 && data.oddValue <= 4) inc = 0.05;
      else if (data.oddValue > 4 && data.oddValue <= 6) inc = 0.1;
      else if (data.oddValue > 6 && data.oddValue <= 10) inc = 0.2;
      else if (data.oddValue > 10 && data.oddValue <= 20) inc = 0.5;
      else if (data.oddValue > 20 && data.oddValue <= 30) inc = 1;
      else if (data.oddValue > 30 && data.oddValue <= 50) inc = 2;
      else if (data.oddValue > 50 && data.oddValue <= 100) inc = 5;
      else if (data.oddValue > 100 && data.oddValue <= 1000) inc = 10;
      else inc = 10;
      // value =
      //   data.marketType !== 'FANCY'
      //     ? data.marketType === 'CASINO'
      //       ? data.casinoOdds
      //       : (data.oddValue - inc).toFixed(2)
      //     : data.oddsSize;
      value =
        data.marketType !== 'FANCY'
          ? (data.oddValue - inc).toFixed(2)
          : data.oddValue;
    }

    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const getmarketType = (marketType: string) => {
    return marketTypeMap[marketType];
  };

  const placeBetHandler = (e) => {
    if (e.key === 'Enter') {
      betPlaceHandler();
    }
  };

  return (
    <div className="exch-betslip-ctn">
      <div className="body-ctn">
        {bettingInprogress ? (
          <div className="betslip-progress">
            {showSpinner ? (
              <div className="centered">
                <div className="spinner loading"></div>
              </div>
            ) : null}
          </div>
        ) : null}

        {bets && bets.length > 0
          ? bets.map((data, index) => (
              <div key={index} className="bet-body">
                <div className="header-row">
                  <p className="event">{data.eventName}</p>
                  <IconButton
                    aria-label="close"
                    className="bet-del-btn"
                    disabled={bettingInprogress}
                    onClick={() => removeExchangeBet(index)}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
                <div className="bet-card">
                  <div className="market">
                    {data.marketType === 'PREMIUM' ? (
                      <>
                        {' '}
                        {data.marketName} @{' '}
                        <span className="odd-value">{data.outcomeDesc}</span>
                      </>
                    ) : data?.marketType === 'FANCY' ? (
                      <>
                        {data?.marketName} {data?.outcomeDesc}
                      </>
                    ) : (
                      <>
                        {data.outcomeDesc} @{' '}
                        <span className="odd-value">
                          {data.displayOddValue
                            ? data.displayOddValue
                            : data.oddValue}
                        </span>
                      </>
                    )}
                  </div>

                  <div className="input-row">
                    <div className="input-row-ctn odds-ctn">
                      <div className="row-header">Odds</div>

                      <div className="row-input-odds">
                        <Button
                          className="odds-btns1"
                          startIcon={<RemoveIcon />}
                          onClick={() => onChangeOddHandler(index, data, 0)}
                          disabled={
                            bettingInprogress || data.marketType !== 'MO'
                          }
                        ></Button>
                        <IonInput
                          type="number"
                          value={
                            data.displayOddValue
                              ? data.displayOddValue
                              : data.oddValue
                          }
                          min="1"
                          mode="md"
                          step="0.01"
                          onKeyDown={(event) => placeBetHandler(event)}
                          disabled={
                            bettingInprogress || data.marketType !== 'MO'
                          }
                          onIonChange={(e) =>
                            exchangeBetOddsChange(
                              index,
                              parseFloat(e.detail.value)
                            )
                          }
                          className="input-design"
                        ></IonInput>

                        <Button
                          className="odds-btns2"
                          startIcon={<AddIcon />}
                          onClick={() => onChangeOddHandler(index, data, 1)}
                          disabled={
                            bettingInprogress || data.marketType !== 'MO'
                          }
                        ></Button>
                      </div>
                    </div>
                    <div className="input-row-ctn stake-ctn">
                      <div className="row-header">
                        {data.betType === 'BACK' ? 'Stake' : 'Profit'}

                        <span
                          className="clear"
                          onClick={() => {
                            if (!bettingInprogress) {
                              setExchangeBetStake(index, -data.amount, 'ADD');
                            }
                          }}
                        >
                          Clear
                        </span>
                      </div>
                      <NumberFormat
                        value={data.amount ? data.amount : null}
                        thousandSeparator={true}
                        decimalScale={2}
                        thousandsGroupStyle="lakh"
                        className="row-input"
                        allowNegative={false}
                        disabled={bettingInprogress}
                        onValueChange={(val) => {
                          setExchangeBetStake(index, val.floatValue, 'SET');
                        }}
                        onKeyDown={(event) => placeBetHandler(event)}
                        style={{
                          height: '39px',
                          border: 1,
                          padding: '10px',
                        }}
                      ></NumberFormat>
                    </div>
                  </div>
                  <div className="quick-bet">
                    {buttonVariables.map((bV, idx) => (
                      <Button
                        key={'qb-btn' + idx}
                        className={
                          bV.stake === data.amount
                            ? 'selected-qb-btn'
                            : 'qb-btn'
                        }
                        disabled={bettingInprogress}
                        onClick={() =>
                          setExchangeBetStake(index, bV.stake, 'ADD')
                        }
                      >
                        +{bV.label}
                      </Button>
                    ))}
                  </div>
                  <div className="profit-loss">
                    <div className="returns">
                      <div className="info">This Bet Profit/Loss</div>
                      <span className="label">
                        {data.betType === 'LAY' ? 'Liabiliy' : 'Profit'}:
                      </span>
                      <div className="amt">
                        {data.marketType === 'MO'
                          ? data.betType === 'BACK'
                            ? (data.amount * (data.oddValue - 1)).toFixed(2)
                            : ((data.oddValue - 1) * data.amount).toFixed(2)
                          : data.marketType === 'BM'
                          ? data.betType === 'BACK'
                            ? (
                                data.amount *
                                ((data.oddValue + 100) / 100 - 1)
                              ).toFixed(2)
                            : (
                                ((data.oddValue + 100) / 100 - 1) *
                                data.amount
                              ).toFixed(2)
                          : data.marketType === "PREMIUM" ? 
                            (data.amount * (data.oddValue - 1)).toFixed(2) 
                          : data.betType === 'BACK'
                          ? (data.amount * ((data.oddValue + 100) / 100 - 1)) //size
                              .toFixed(2)
                          : (
                              ((data.oddValue + 100) / 100 - 1) * //size
                              data.amount
                            ).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>

      <div className="bet-footer">
        <div className="stake-section">
          <div className="stake-value">
            Coins: {bets.reduce((a, v) => a + v.amount, 0)}
          </div>
          <div className="stake-label">Total stake</div>
        </div>
        <div className="place-section">
          <Button
            className="place-btn"
            disabled={bettingInprogress}
            onClick={betPlaceHandler}
          >
            <div className="btn-content">
              <div className="label">
                {!bets[0]?.isOddsUpdated ? 'Place Bet' : 'Accept odds change'}
              </div>
            </div>
          </Button>
        </div>
      </div>
      {errorMsg !== '' ? (
        <div className="err-section">
          <div className="err-box">
            <div className="msg">{errorMsg && errorMsg}</div>
          </div>
        </div>
      ) : null}
      {successMsg !== '' ? (
        <div className="err-section">
          <div className="success-box">
            <div className="msg">{successMsg && successMsg}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const selectedEvent = state.exchangeSports.selectedEvent;
  return {
    bets: state.exchBetslip.bets,
    selectedEvent: state.exchangeSports.selectedEvent,
    selectedEventType: state.exchangeSports.selectedEventType,
    buttonVariables: state.exchBetslip.buttonVariables,
    bettingInprogress: state.exchBetslip.bettingInprogress,
    oneClickAmount: state.exchBetslip.oneClickAmount,
    isOneClickEnable: state.exchBetslip.isOneClickEnable,
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
    secondaryMatchOdds: getSecondaryMatchOddsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    cancelBetSuccess: (betId: string) => dispatch(cancelBetSuccess(betId)),
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange(index, odds)),
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: 'ADD' | 'SET') =>
      dispatch(setExchangeBetStake(index, amount, type)),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    fetchOpenBets: (eventId: string | string[]) =>
      dispatch(fetchOpenBets(eventId)),
    addOpenBets: (openBets) => dispatch(addOpenBets(openBets)),
    setBettingInprogress: (val: boolean) => dispatch(setBettingInprogress(val)),
    updateSuspendedMarkets: (suspendedMarket: SuspendedMarketDTO) =>
      dispatch(updateSuspendedMarkets(suspendedMarket)),
    updateDisabledMarkets: (disabledMarket) =>
      dispatch(updateDisabledMarkets(disabledMarket)),
    updateMultiDisabledMarkets: (disabledMarket) =>
      dispatch(updateMultiDisabledMarkets(disabledMarket)),
    updateMultiSuspendedMarkets: (suspendedMarket: SuspendedMarketDTO) =>
      dispatch(updateMultiSuspendedMarkets(suspendedMarket)),
    triggerFetchOrders: () => dispatch(triggerFetchOrders()),
    triggerMultiFetchOrders: (eventId: string) =>
      dispatch(triggerMultiFetchOrders(eventId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchBetslip);
